import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ReplicatedService } from './replicated.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'replicate-vapp',
  providers: [
    ReplicatedService, TranslateService
  ],
  styles: [require('./replicated-vdc.scss')],
  template: require('./replicate-vapp.html')
})

export class ReplicateVapp {
  @Input('isVisible') isVisible: boolean;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Output('onClose') selfClose = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private description2 = "";
  private isRequestPending: boolean = false;

  constructor(public service: ReplicatedService, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit() {
    this.replicateVapp();
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(changes && changes.hasOwnProperty('selectedObject') && changes.selectedObject && changes.selectedObject.hasOwnProperty('currentValue')
      && changes.selectedObject.currentValue  ) {
        this.description2 = this.translate.instant('dpsModule.replicatedVdc.vappList.modalDialog.replicateNow.confirmMsg');
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  replicateVapp() {
    if(this.selectedVDC && this.selectedVDC.id !== '' &&
       this.selectedObject && this.selectedObject[0] && this.selectedObject[0].id && this.selectedObject[0].id !== '') {
          this.isRequestPending = true;
          let data = {'retention': {'days': 50 }};  // dummy retention value since removed retention field from UI (data.retentionPeriod)
          this.subscribeHandler = this.service.replicateNow(data, this.selectedVDC.id, this.selectedObject[0].id)
            .subscribe(
              res => {
                this.closeSelf();
              },
              error => this.handleError(error, 'delete vApp'),
              () => this.handleCompleted('replicate vApp')
            );
    }
    else
      this.handleError('Incorrect VDC or vApp information');
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: "close"
      });
    }
  }

  handleError(error, msg = "") {
    this.isRequestPending = false;
    this.service.logError(error, msg);
  }

  handleCompleted(msg = "") {
    this.isRequestPending = false;
    this.service.logOperationCompleted(msg)
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/replicate-vapp.component.ts